import React from "react";
import { Link } from "react-router-dom";
import "./cta.css";

const CTALarge = ({ to, text, icon: Icon }) => {
  return (
    <Link to={to} className="cta-fullwidth">
      <h3 className="cta-text">{text}</h3>
      {Icon && <Icon className="cta-icon" />}
    </Link>
  );
};

export default CTALarge;
